module.exports = __webpack_public_path__ + "img/SES_160254105.5b731331.jpg";